/*
            語音選圖處理步驟
            1.預期指令列表 show image, delete p1, next page previous page, save to finding 1, save to landmark cecum,
            2.更新voiceSelectionCommand 讓前端去判斷要執行 action以及參數
            */
let command = ''
const staticCommands = [
    'show me key images',
  'show to image',
  'show selected images',
  'next page',
  'previous page',
  'off',
]
export default function voiceSelectionCommandChecker(command, commandArr) {
    const combineStr = commandArr.join(' ').toLowerCase()
    const staticCommandIndex = staticCommands.findIndex((item) => {
        const regex = new RegExp(`^${item}(.*)`)
        return regex.test(combineStr)
    })
    if (staticCommandIndex !== -1) {
        return {
            action: staticCommands[staticCommandIndex]
        }
    }
    if (combineStr.match(/^save(.*)/)) {
        // 確認是save to finding 1 or save to landmark cecum or save to finding 2 landmark cecum
        const findingMatch = combineStr.match(/^save to finding ([0-9]+)/)
        if(findingMatch){
            // 'SAVE', 'TO', 'FINDING', '1', 'LANDMARK', 'CECUM'
            // console.log(`'${combineStr}'`)
            // SAVE TO FINDING 1 LANDMARK Landmark CECUM
            let comboLandmarkMatch = combineStr.match(/^save to finding [0-9]+ landmark landmark (.*)$/)
            if (!comboLandmarkMatch) {
                comboLandmarkMatch = combineStr.match(/^save to finding [0-9]+ landmark (.*)$/)
            }
            if(comboLandmarkMatch){
                return {
                    action: 'save to finding landmark',
                    target: findingMatch[1],
                    target2: comboLandmarkMatch[1].replace('landmark ', '').replace('location ', '')
                }
            }
            return {
                action: 'save to finding',
                target: findingMatch[1]
            }
            
        }
        const landmarkMatch = combineStr.match(/^save to landmark (.*)$/)
        if(landmarkMatch){
            console.log('landmarkMatch', landmarkMatch)
            return {
                action: 'save to landmark',
                target: landmarkMatch[1].replace('landmark ', '').replace('location ', '')
            }
        }
        return {
            action: 'save',
            target: ''
        }
    }
    const deleteMatch = combineStr.match(/^delete p([0-9]+)/)
    if (deleteMatch) {
        return {
            action: 'delete',
            target: deleteMatch[1]
        }
    }
    return null
}
